import { render, staticRenderFns } from "./subscriberDialog.vue?vue&type=template&id=55c2da10&scoped=true"
import script from "./subscriberDialog.vue?vue&type=script&lang=js"
export * from "./subscriberDialog.vue?vue&type=script&lang=js"
import style0 from "./subscriberDialog.vue?vue&type=style&index=0&id=55c2da10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c2da10",
  null
  
)

export default component.exports